import { IconProduct } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentProduct';
const links = [
  { title: 'Coverage', href: '/product/coverage' },
  { title: 'Price lists', href: '/product/pricelist' },
  { title: 'Product Sheet', href: '/product/product-sheet' },
  { title: 'Terms and Conditions', href: '/product/terms-and-conditions' },
];
const productSubNav = () =>
  subNav({
    id: navId,
    title: 'Product',
    href: '/product',
    icon: IconProduct,
    links,
  });
export default productSubNav;
